module.exports = __webpack_public_path__ + "static/media/mobile-logo.fd994cc4.svg";